export default __webpack_public_path__ + "static/media/1.42238224.jpg";